(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const durations = () => reduce.matches || document.body.dataset.motion === 'false' ? 0 : 390;
  const animations = new WeakMap();
  function panelFor(details) { return details.querySelector(':scope > .header-panel, :scope > .nav-dropdown'); }
  function change(details, open, focus = false) {
    const panel = panelFor(details), summary = details.querySelector(':scope > summary');
    if (!panel || !summary) return;
    animations.get(details)?.cancel();
    if (open) {
      document.querySelectorAll('[data-header] details[open]').forEach(other => {
        if (other !== details && !other.contains(details) && !details.contains(other)) change(other, false);
      });
      details.open = true;
    }
    const targetHeight = panel.scrollHeight;
    details.dataset.expanded = String(open);
    summary.setAttribute('aria-expanded', String(open));
    panel.inert = !open;
    panel.setAttribute('aria-hidden', String(!open));
    const duration = durations();
    const finish = () => {
      details.open = open;
      panel.style.removeProperty('height');
      if (open && focus) panel.querySelector('input[type="search"]')?.focus({ preventScroll: true });
      if (!open && details.contains(document.activeElement) && document.activeElement !== summary) summary.focus({ preventScroll: true });
    };
    if (!duration || !panel.animate) { finish(); return; }
    const animation = panel.animate(open ? [{ height: '0px', opacity: 0 }, { height: targetHeight + 'px', opacity: 1 }] : [{ height: panel.getBoundingClientRect().height + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration, easing: 'cubic-bezier(.22,1,.36,1)' });
    animations.set(details, animation);
    animation.onfinish = finish;
  }
  function setup(root = document) {
    root.querySelectorAll('[data-header] details').forEach(details => {
      const panel = panelFor(details), summary = details.querySelector(':scope > summary');
      if (!panel || !summary) return;
      summary.setAttribute('aria-expanded', String(details.open));
      panel.inert = !details.open;
    });
    const header = document.querySelector('[data-header] .header-inner');
    if (header) document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
  }
  document.addEventListener('click', event => {
    const summary = event.target.closest('[data-header] summary');
    if (summary && panelFor(summary.parentElement)) {
      event.preventDefault();
      change(summary.parentElement, summary.parentElement.dataset.expanded !== 'true', true);
      return;
    }
    document.querySelectorAll('[data-header] details[open]').forEach(details => {
      if (!details.contains(event.target) || event.target.closest('a')) change(details, false);
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-header] details[open]').forEach(details => change(details, false));
  });
  document.addEventListener('focusin', event => {
    document.querySelectorAll('[data-header] details[open]').forEach(details => {
      if (!details.contains(event.target)) change(details, false);
    });
  });
  document.addEventListener('shopify:section:load', () => setup());
  addEventListener('resize', () => setup());
  addEventListener('pageshow', () => { document.querySelectorAll('[data-header] details[open]').forEach(details => change(details, false)); });
  setup();
})();
